var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoOutline = function SvgInfoOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,23c-2.9,0-5.7-1.1-7.8-3.2C2.1,17.7,1,14.9,1,12s1.1-5.7,3.2-7.8C6.3,2.1,9.1,1,12,1s5.7,1.1,7.8,3.2             C21.9,6.3,23,9.1,23,12s-1.1,5.7-3.2,7.8C17.7,21.9,14.9,23,12,23z M12,3C9.6,3,7.3,3.9,5.6,5.6S3,9.6,3,12s0.9,4.7,2.6,6.4             c1.7,1.7,4,2.6,6.4,2.6s4.7-0.9,6.4-2.6c1.7-1.7,2.6-4,2.6-6.4s-0.9-4.7-2.6-6.4C16.7,3.9,14.4,3,12,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,17c-0.6,0-1-0.4-1-1v-5c0-0.6,0.4-1,1-1s1,0.4,1,1v5C13,16.6,12.6,17,12,17z M12,8c-0.6,0-1-0.4-1-1             s0.4-1,1-1s1,0.4,1,1S12.6,8,12,8z"
  }))));
};
export default SvgInfoOutline;